import {
  CreateGuestOrderRequest,
  CreateOrderRequest,
  GuestOrderTracking,
  OrderEstimateRequest,
  OrderEstimateResponse,
  Order,
  OrderList,
  OrderSearch,
  OrderStatusObject,
  UpdateGuestShippingInfoRequest,
  UpdateShippingInfoRequest,
} from '../types/orders';
import { BaseApiService } from './baseApiService';

/**
 * Service for order operations
 */
class OrderService extends BaseApiService {
  async createOrder(data: CreateOrderRequest): Promise<Order> {
    await this.ensureInitialized();
    const response = await this.api.post('/order', data);
    return response.data;
  }

  async estimateOrder(
    data: OrderEstimateRequest
  ): Promise<OrderEstimateResponse> {
    await this.ensureInitialized();
    const response = await this.api.post('/order/estimate', data);
    return response.data;
  }

  async createGuestOrder(
    data: CreateGuestOrderRequest
  ): Promise<GuestOrderTracking> {
    await this.ensureInitialized();
    const response = await this.api.post('/order/guest', data);
    return response.data;
  }

  async getOrders(params?: OrderSearch): Promise<OrderList> {
    await this.ensureInitialized();
    const response = await this.api.get('/order', { params });
    return response.data;
  }

  async getOrder(orderId: number): Promise<Order> {
    await this.ensureInitialized();
    const response = await this.api.get(`/order/${orderId}`);
    return response.data;
  }

  async updateShippingInfo(
    orderId: number,
    shippingInfo: UpdateShippingInfoRequest
  ): Promise<Order> {
    await this.ensureInitialized();
    const response = await this.api.put(
      `/order/${orderId}/shipping`,
      shippingInfo
    );
    return response.data;
  }

  async updateGuestShippingInfo(
    shippingInfo: UpdateGuestShippingInfoRequest
  ): Promise<void> {
    await this.ensureInitialized();
    await this.api.put('/order/guest/shipping', shippingInfo);
  }

  async trackGuestOrder(
    orderNumber: string,
    email: string
  ): Promise<GuestOrderTracking> {
    await this.ensureInitialized();
    const response = await this.api.post('/order/guest/track', {
      orderNumber,
      email,
    });
    return response.data;
  }

  async getGuestOrderByToken(
    trackingToken: string
  ): Promise<GuestOrderTracking> {
    await this.ensureInitialized();
    const response = await this.api.get(`/order/guest/token/${trackingToken}`);
    return response.data;
  }

  async getOrderStatuses(): Promise<OrderStatusObject[]> {
    await this.ensureInitialized();
    const response = await this.api.get('/order/statuses');
    return response.data;
  }
}

export const orderService = new OrderService();
export default orderService;
